// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"538":"0adeaa67","787":"22edae46","983":"8be5fe36"}[chunkId] + ".chunk.js";
};